import React from "react";
import "./footer.css";
import { FaFacebookF } from "react-icons/fa";
import { AiFillLinkedin } from "react-icons/ai";
import { BsGithub } from "react-icons/bs";

const Footer = () => {
  return (
    <footer id="footer">
      <a href="#" className="footer__logo">
        Maty
      </a>
      <ui className="perammlinks">
        <li>
          <a href="#">בית</a>{" "}
        </li>
        <li>
          <a href="#about">אודות</a>{" "}
        </li>
        <li>
          <a href="#experience">ניסיון</a>{" "}
        </li>
        <li>
          <a href="#portfolio">תיק עבודות</a>{" "}
        </li>
        <li>
          <a href="#testimonials">המלצות</a>{" "}
        </li>
        <li>
          <a href="#contact">צור קשר</a>{" "}
        </li>
      </ui>

      <div className="footer__socials">
        <a href="https://www.facebook.com/maty770/">
          <FaFacebookF />
        </a>
        <a href="https://www.linkedin.com/in/maty/">
          <AiFillLinkedin />{" "}
        </a>
        <a href="https://github.com/MatyMusic">
          {" "}
          <BsGithub />{" "}
        </a>
      </div>
      <div className="footer__copyright">
        <small>&copy; כל הזכויות שמורות Maty Dev770 </small>
      </div>
    </footer>
  );
};

export default Footer;
